import Vue from 'vue'
import store from '@/store/store'
import { messages } from '@/i18n/messages'

function formatMessage(text, params) {
  if (!params || typeof params !== 'object') return text
  return String(text).replace(/\{(\w+)\}/g, (match, k) => {
    return params[k] !== undefined ? params[k] : match
  })
}

function lookupMessage(lang, key, params) {
  const dict = messages[lang] || messages.en
  if (dict[key] !== undefined) return formatMessage(dict[key], params)
  const other = lang === 'en' ? messages.th : messages.en
  if (other[key] !== undefined) return formatMessage(other[key], params)
  return formatMessage(key, params)
}

/**
 * Manual i18n: reactive $t(key, params) via Vuex (no vue-i18n).
 * Lookup reads store.state.locale.lang directly so UI always tracks language changes
 * (avoids Vuex getter-returning-function cache edge cases).
 */
export function installManualI18n() {
  Vue.prototype.$t = function t(key, params) {
    if (this && this.$store) {
      const lang = this.$store.state.locale.lang
      return lookupMessage(lang, key, params)
    }
    const lang = store.state.locale.lang
    return lookupMessage(lang, key, params)
  }

  Vue.prototype.dashboardText = function dashboardText(thText, enText) {
    const lang = (this && this.$store ? this.$store.state.locale.lang : store.state.locale.lang) || 'th'
    return String(lang).toLowerCase().startsWith('en') ? enText : thText
  }

  const lang = store.state.locale.lang
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lang === 'en' ? 'en' : 'th'
  }
}
